export default __webpack_public_path__ + "static/media/ReekrajRoyResume.47673251.pdf";